<template>
  <div v-if="isVisible">
    <div class="container max-width-mobile">
      <h2 class="title title--section">{{ content.ReceiptLoyaltyAward.title }}</h2>

      <div class="layout layout--horizontal">
        <img
          v-if="merchant.options.loyaltyImageUrl"
          class="image image--logo-smallest"
          :alt="merchant.name"
          :src="merchant.options.loyaltyImageUrl"
        >

        <p class="grow">{{ content.ReceiptLoyaltyAward.description }}</p>
      </div>
    </div>
  </div>
</template>



<script>
  import parseReceiptLoyaltyRewards from '@/helpers/parse-receipt-loyalty-rewards';
  import events from '@/services/events';
  import { mapGetters } from 'vuex';



  export default {
    name: 'LoyaltyReceiptSummary',

    props: {
      isPayAtTable: {
        type: Boolean,
        default: false
      },

      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('offers', ['loyalty']),

      isVisible() {
        return this.receipt.loyaltyEngagementSummary?.loyaltyAwardDisplayFormat === 'Message';
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.receipt.loyaltyEngagementSummary?.loyaltyAwardDisplayFormat === 'AwardDetails') {
          const rewardsSummary = parseReceiptLoyaltyRewards(this.receipt.loyaltyEngagementSummary);
          if (rewardsSummary.earnedNewReward) {
            // this.$triggerGoogleTrackingEvent('EarnedReward', 'Loyalty');

            this.$triggerNewRelicEvent('EarnedReward', 'Information', 'Earned Reward');
          }

          events.emit('loyalty-popup-card:open', {
            disableOffersPageLink: this.isPayAtTable,
            receipt: {
              ...this.receipt,
              rewardsSummary
            },
            refreshData: true
          });
        }
      }
    }
  };
</script>
